<script>
export default {
    name:'orders',
    props:{
        order_info:{
            default:()=>{
                return {
                    goods_child:[]
                }
            },
            type:Object
        }
    },
    computed:{
        goods_ids(){
            let goods_child = this.order_info.goods_child;
            let newArr = [];
            for (let i=0;i<goods_child.length;i++){
                if(i===0){
                    newArr.push(goods_child[i])
                }
                if(i<goods_child.length-1){
                    if(goods_child[i].id !== goods_child[i+1].id){
                        newArr.push(goods_child[i])
                    }
                }else{
                    if(goods_child[i-1].id !== goods_child[i].id){
                        newArr.push(goods_child[i])
                    }
                }
            }
            return newArr
        }
    },
    mounted(){
        // console.log(this.goods_ids[0])
    },
    filters:{
        change_unit(x){
            let ret = parseFloat(x) / parseFloat(10);
            let rets = (Math.round(ret * 100) / 100);
            return rets.toFixed(2)
        },
        img($url){
            if(/^http/.test($url)){
                return $url.replace('com/n0', 'com/img');
            }else if(/^\/.{4}\//.test($url)){
                // /2017/12/25/5a40b39bc9819.jpg
                return 'http://admin.fufentong.com/media/upload'+$url;
            }else{
                // /tmp/uploads/20181127/4410c3daa57707828e7e242aa97395fa.png
                return 'https://mapi.fufentong.com'+$url;
            }
        },
        OrderStatus(order_info) {
            let {status, pay_status, shipping_status} = order_info;
            if (pay_status == 0 && status != 2) {
                return '未付款';
            }
            else if (status == 1 && shipping_status == 0 && pay_status == 1) {
                return '待发货';
            } else if (status == 1 && shipping_status == 2 && pay_status == 1) {
                return '已发货';
            } else if (status == 1 && shipping_status == 3 && pay_status == 1) {
                return '已收货';
            } else if (status == 5 && shipping_status == 3 && pay_status == 1) {
                return '已结算';
            } else if (status == 4 && shipping_status == 4 && pay_status == 1) {
                return '已退货';
            } else if (status == 7 && shipping_status == 4 && pay_status == 1) {
                return '已换货';
            } else if (status == 2) {
                return '已取消';
            }
        }
    }
}
</script>

<template>
    <div class="orders-ite">
        <el-card
        >
            <p class="order-title">订单编号：{{order_info.order_sn}}</p>
            <div class="order-table">
                <table>
                    <tr>
                        <td style="padding:5px">商品</td>
                        <td style="padding:5px">单价</td>
                        <td style="padding:5px">数量</td>
                        <td style="padding:5px">收货人</td>
                        <td style="padding:5px">总价</td>
                        <td style="padding:5px">订单状态</td>
                    </tr>
                    <tr 
                    v-for="(ite,ind) in goods_ids"
                    :key="ind"
                    >
                        <td class="info">
                            <div class="clearfix">
                                <img :src="ite.default_img | img" class="goods-img fl">
                                <span class="fl al">{{ite.product_name}}</span>
                            </div>
                        </td>
                        <td class="price">{{ite.jifen|change_unit}}</td>
                        <td class="nums">{{ite.nums}}</td>
                        <td class="receiver" :rowspan="goods_ids.length" v-if="ind<1">{{order_info.shouhuo_name}}</td>
                        <td class="price" :rowspan="goods_ids.length" v-if="ind<1">{{ order_info.subtotal | change_unit }}</td>
                        <td class="status" :rowspan="goods_ids.length" v-if="ind<1">{{order_info | OrderStatus}}</td>
                    </tr>
                </table>
            </div>
        </el-card>
    </div>
</template>

<style lang="stylus" scoped>
.orders-ite
    overflow auto
    margin-bottom 20px
    .order-title
        height: 36px;
        line-height: 36px;
    .order-table
        position relative
        width 100%
        table
            width: 100%;
            font-size: 12px;
            background-color: #fff;
            border-collapse: collapse;
            .info   
                padding 20px
                width 350px
                font-size 12px
                span 
                    width 220px
                    margin-left 10px
                .goods-img
                    display inline-block
                    width 60px
                    height 60px
            td
                border: 1px solid #ccc;
                text-align center
</style>


